import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import IconSvg from "../../../../SharedComponents/IconSvg";

const OurDifferences = ({ headerText, differencesArray, children }) => {
  return (
    <Row className="d-flex justify-content-evenly mx-0 mt-5">
      <Col xs={11} md={5} className={"text-12 text-lg-20 align-content-center pb-4"}>
        {headerText && (
          <Row
            className={"mx-lg-2 mb-4 EB-Garamond fw-medium text-36 text-lg-56 text-color-primary lh-1"}
            style={{ letterSpacing: "-1px" }}
          >
            <Col>{headerText}</Col>
          </Row>
        )}

        <Row className={"mx-lg-2"}>
          <Col style={{ color: "#626C77" }}>{children}</Col>
        </Row>
      </Col>

      <Col xs={11} md={7} lg={6} xl={5} xxl={4}>
        <Row>
          {differencesArray.map((difference, index) => {
            return (
              <Col key={index} style={{ minWidth: 270, color: "#626C77" }} lg={6} className={"mb-4"}>
                <Row>
                  <Col xs={"auto"}>
                    <IconSvg icon={"landing-page-bullet"}></IconSvg>
                  </Col>
                  <Col className={"text-color-primary fw-semibold text-18"}>{difference.header}</Col>
                </Row>

                {difference.text}
              </Col>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
};
export default OurDifferences;
